import { Zoom } from '@mui/material';
import { useRef } from 'react';
import { useInViewport } from 'react-in-viewport';
import { useFormattedYears } from '../../../../../../hooks/formatters';
import { THEME } from '../../../../../../themes';
import { WIDGET_COLORS } from '../../consts';
import {
  BubbleContainer, IndustryCircle, PlaceholderCircle, TooltipBubble,
} from './bubble-chart.styled';

const MAX_PLACEHOLDERS_IN_LINE = 9;
const MIN_SIZE = 20;
const MAX_SIZE = 130;

type BubbleChartProps = {
  chartData: ExperienceByIndustryChart[],
}

export const BubbleChart = ({
  chartData,
}: BubbleChartProps): JSX.Element => {
  const containerRef = useRef(null);
  const {
    inViewport,
    enterCount,
  } = useInViewport(
    containerRef,
    {},
    {},
  );
  const getFormattedYears = useFormattedYears();
  const totalYears = chartData
    .reduce((prev: number, current: ExperienceByIndustryChart) => {
      return  prev + current.tenureInMonths;
    }, 0);

  const placeHolders = Array.from({
    length: MAX_PLACEHOLDERS_IN_LINE  - chartData.length,
  }, (v, i) => i);

  const calcCircleSize = (value: number) => {
    return Math.floor((value * ((MAX_SIZE - MIN_SIZE) / totalYears)) + MIN_SIZE);
  };

  return (
    <BubbleContainer ref={ containerRef }>
      <PlaceholderCircle
        size={ 8 }
        color={ THEME.COLORS.PRIMARY }
      />
      {
        chartData.map((item: ExperienceByIndustryChart, index: number) => {
          const industry = item?.industry || '';
          const experience = (item?.tenureInMonths &&
          getFormattedYears(item.tenureInMonths)) ||
          '';

          return (
            <TooltipBubble
              key={ `${industry} ${experience}` }
              TransitionComponent={ Zoom }
              placement="top-start"
              title={ `${industry} ${experience}` }
            >
              <IndustryCircle
                index={ index }
                size={ calcCircleSize(item.tenureInMonths) }
                color={ WIDGET_COLORS[index % WIDGET_COLORS.length] }
                isEnableAnimation={ inViewport && enterCount === 1 }
              />
            </TooltipBubble>
          );
        })
      }
      {placeHolders.map((item) => {
        return (
          <PlaceholderCircle
            key={ item }
            size={ 8 }
            color={ THEME.COLORS.PRIMARY }
          />
        );
      })}
    </BubbleContainer>
  );
};
